import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

export default function LanguageSwitcher() {
  const [isOpen, setIsOpen] = useState(false);
  const { i18n } = useTranslation();

  const languages = [
    { code: 'cz', name: 'Čeština', flag: 'https://flagcdn.com/w20/cz.png' },
    { code: 'en', name: 'English', flag: 'https://flagcdn.com/w20/gb.png' },
    { code: 'de', name: 'Deutsch', flag: 'https://flagcdn.com/w20/de.png' },
    { code: 'sk', name: 'Slovenčina', flag: 'https://flagcdn.com/w20/sk.png' }
  ];

  const changeLanguage = (locale: string) => {
    i18n.changeLanguage(locale);
    // Force re-render of components that use currency formatting
    window.dispatchEvent(new Event('languageChanged'));
    setIsOpen(false);
  };

  const normalizedLanguage = i18n.language.split('-')[0].toLowerCase();
  const currentLanguage = languages.find(lang => lang.code === normalizedLanguage) || languages[0];

  return (
    <div className="fixed top-4 right-4 z-50">
      <div className="relative">
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => setIsOpen(!isOpen)}
          className="flex items-center bg-black/60 backdrop-blur-md border border-[#EE1C23]/30 rounded px-3 py-1 text-white hover:border-[#EE1C23]/50 transition-colors"
        >
          <img src={currentLanguage.flag} alt={currentLanguage.name} className="w-5 h-3" />
          <span className="text-sm font-medium ml-2">{currentLanguage.code === 'cz' ? 'CZ' : currentLanguage.code.toUpperCase()}</span>
        </motion.button>

        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -10, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ duration: 0.2 }}
            className="absolute right-0 mt-2 bg-black/90 backdrop-blur-md border border-[#EE1C23]/30 rounded-lg shadow-xl min-w-[120px]"
          >
            {languages
              .filter(lang => lang.code !== normalizedLanguage)
              .map((lang) => (
                <motion.button
                  key={lang.code}
                  whileHover={{ backgroundColor: 'rgba(255, 255, 255, 0.1)' }}
                  onClick={() => changeLanguage(lang.code)}
                  className="flex items-center w-full px-4 py-2.5 text-left text-white transition-colors whitespace-nowrap first:rounded-t-lg last:rounded-b-lg"
                >
                  <img src={lang.flag} alt={lang.name} className="w-5 h-3 flex-shrink-0" />
                  <span className="text-sm font-medium ml-2">{lang.code === 'cz' ? 'CZ' : lang.code.toUpperCase()}</span>
                </motion.button>
              ))}
          </motion.div>
        )}
      </div>
    </div>
  );
}